import { StyleSheet, View, ViewProps } from 'react-native';
import { Circle, Svg } from 'react-native-svg';

export const CircularProgress = ({
  size,
  bgColor,
  pgColor,
  progressPercent,
  strokeWidth,
  style,
  children,
  contentStyle,
}: {
  size: number;
  bgColor: string;
  pgColor: string;
  strokeWidth: number;
  progressPercent: number;
  style?: ViewProps['style'];
  contentStyle?: ViewProps['style'];
  children?: React.ReactNode;
}) => {
  const radius = (size - strokeWidth) / 2;
  const circum = radius * 2 * Math.PI;
  const svgProgress = 100 - progressPercent;

  return (
    <View style={[style, styles.mainContainer]}>
      <Svg width={size} height={size}>
        {/* Background Circle */}
        <Circle
          stroke={bgColor}
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />

        {/* Progress Circle */}
        <Circle
          stroke={pgColor}
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeDasharray={`${circum} ${circum}`}
          strokeDashoffset={radius * Math.PI * 2 * (svgProgress / 100)}
          strokeLinecap="round"
          transform={`rotate(-90, ${size / 2}, ${size / 2})`}
          strokeWidth={strokeWidth}
        />
      </Svg>
      <View style={[contentStyle, styles.childrenContainer]}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    position: 'relative',
  },
  childrenContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
  },
});
